import { Avatar, Tooltip } from "@mui/material";
import { MdHighlight, MdMapsHomeWork } from "react-icons/md";
import { FC, ReactNode } from "react";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SchoolIcon from '@mui/icons-material/School';
import theme from "src/theme/light";

interface ISelos {
    label: string | ReactNode;
    title?: string;
    onlyIcon?: boolean;
}


const Selo: FC<ISelos> = ({ label, title = "", onlyIcon = false }) => {
    
    const resolveLabel = (label: ReactNode | string) => {
        if (typeof label !== "string") {
            return label;
        }

        switch (label) {
            case "DESTAQUE":
                return <MdHighlight />;
            case "LANCAMENTO":
                return <NewReleasesIcon />;
            case "PROMOCIONAL":
                return <LocalOfferIcon />;
            case "TREINAMENTO":
                return <SchoolIcon />;
            case "SHOWROOM":
                return <MdMapsHomeWork />;
            default:
                return "";
        }
    }

    return onlyIcon ? <>{resolveLabel(label)}</> : (<Tooltip title={title}>
        <Avatar className="Selos" variant="rounded" alt={title} color={theme.palette.primary.main} style={{color: theme.palette.primary.main, background: theme.palette.common.white, border: `1px solid ${theme.palette.grey[200]}`, marginRight: theme.spacing(1)}}>
            {resolveLabel(label)}
        </Avatar>
    </Tooltip>)
}

export { Selo }